<template>
  <v-snackbar v-model="snackbarOpen" bottom :timeout="snackbarTimeout" v-if="snackbarOpen">
    {{ text }}
    <v-btn color="primary" @click="setOpen(false)">Close</v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Snackbar',
  computed: {
    snackbarOpen: {
      set (open) {
        return this.setOpen(open)
      },
      get () {
        return this.open
      }
    },
    snackbarTimeout: {
      set (miliseconds) {
        return this.setTimeout(miliseconds)
      },
      get () {
        return this.timeout
      }
    },
    ...mapGetters('Snackbar', [
      'open',
      'text',
      'timeout'
    ])
  },
  methods: {
    ...mapActions('Snackbar', [
      'setOpen',
      'setTimeout'
    ])
  }
}
</script>
